import { getDatasetUrlPath } from "layout/DataExplorer/helpers.js";
import { DATASET_PATHS } from "layout/DataExplorer/DataExplorerConstants.js";

import {
	ALL_PATHS,
	COMPARE_ROUTE,
	MOE_ROUTE,
	HELP_ROUTE,
	NARRATIVES_ROUTE,
	ENTITY_VIEW_ROUTE,
	CORP_RECORDS_ROUTE,
	CONNECTOR_ROUTE,
	EXPLORER_ROUTE,
	EVENTS_ROUTE,
	CONNECTOR_PATH,
	EXPLORER_PATH,
} from "constants/constants.js";


export const findPage = ({ availableTabs, userId, location, currentDatasetId }) => {

	const splitPath = location?.pathname.split('/');
	const locationRoot = splitPath ? splitPath[1] : undefined;
	const datasetFromPath = splitPath ? splitPath[2] : undefined;
	const idFromPath = splitPath ? splitPath[3] : undefined;

	// // FLAG_REMOVE_CURRENT_TAB_COOKIE_STORAGE
	const savedTab = getCookie("currenttab", userId); // string matches router slug ("narratives", not "/narratives")
	let tabToLoad = locationRoot || savedTab;
	if (tabToLoad === COMPARE_ROUTE || tabToLoad === MOE_ROUTE || tabToLoad === EVENTS_ROUTE) {
		tabToLoad = NARRATIVES_ROUTE;
	}
	let ret = `/${availableTabs.default}`;

	if (locationRoot === HELP_ROUTE) {
		ret = `${location.pathname}`;
	} 

	else if (availableTabs.explorer && (locationRoot === EXPLORER_ROUTE)) {
		const validDatasetPaths = DATASET_PATHS.map(x => x.path);
		if (validDatasetPaths.includes(datasetFromPath)) {
			ret = `${location.pathname}`;
		}
		else {
			ret = EXPLORER_PATH;
		}
	} 

	else if (availableTabs.connector && (locationRoot === CONNECTOR_ROUTE)) {
		const validDatasetPaths = DATASET_PATHS.map(x => x.path);
		if (validDatasetPaths.includes(datasetFromPath)) {
			ret = `${location.pathname}`;
		}
		else {
			ret = CONNECTOR_PATH;
		}
	} 

	else if (availableTabs.explorer && (locationRoot === ENTITY_VIEW_ROUTE || locationRoot === CORP_RECORDS_ROUTE)) {
		if (datasetFromPath && idFromPath) {
			ret = `${location.pathname}`;
		}
		else {
			ret = EXPLORER_PATH;
		}
	} 

	else if (tabToLoad && availableTabs[tabToLoad]) {
		ret = `/${tabToLoad}`;
	}
	
	if (ret === EXPLORER_PATH) {
		const datasetPathToUse = getDatasetUrlPath(currentDatasetId);
		ret += ("/" + datasetPathToUse);
	}

	return ret;
};

export const deleteCookie = function(name, path, domain) {
	document.cookie = `${name}=;path=${path};expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
};

const deleteAllPathCookies = function(cname) {
	const domain = window.location.hostname;
	// Delete for all known high-level paths
	for (let i=0; i<ALL_PATHS.length; i++) {
		deleteCookie(cname, ALL_PATHS[i], domain);
	}
	// Delete for current URL path
	const currPath = window.location.pathname;
	if (currPath !== "/") {
		deleteCookie(cname, currPath, domain);
	}
};

export const getCookie = (cname, userId) => {
	// Generate the actual cookie name to use
	const name = userId ? `${userId}-${cname}=` : `${cname}=`;
	// Delete any (non-root) path specific versions of the cookie. Note: These may 
	// exist due to legacy code not originally specifying explicit root paths.
	// We want to clean them up if they are found as they will override the root
	// version that the app now uses, effectivly breaking the cookies further use
	deleteAllPathCookies(name);
	// Get and decode the (cleaned) list of cookies
	const decodedCookie = decodeURIComponent(document.cookie);
	// Search for the requested cookie name in the list
	const ca = decodedCookie.split(";");
	for (let i = 0; i < ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) === " ") {
			c = c.substring(1);
		}
		if (c.indexOf(name) === 0) {
			return c.substring(name.length, c.length);
		}
	}
	return "";
};

export const setCookie = (cname, cvalue, userId, isSessionCookie=false) => {
	// Generate the cookie name
	const cookieName = userId ? `${userId}-${cname}` : cname;
	// Generate an expiry time for the cookie (1 year for non-session cookies)
	const expiresDate = new Date();
	const oneYearInMs = 365 * 86400 * 1000;
	expiresDate.setTime(expiresDate.getTime() + oneYearInMs);
	const expiresVal = isSessionCookie ? "" : `expires=${expiresDate.toUTCString()};`;
	// Generate an explicit (root) path for the cookie to avoid it being tied to the current path
	const path = 'path=/'
	// Generate & store the cookie
	document.cookie = `${cookieName}=${cvalue};${expiresVal}${path}`;
};


// Checks if a string has at least 8 characters, both upper and lowercase letters, and a number
// Returns boolean
export const isPasswordValid = (password) => {
	let passwordValid = true;

	if (password.length < 8) {
		passwordValid = false;
	}
	if (!password.match(/[a-z]/)) {
		passwordValid = false;
	}
	if (!password.match(/[A-Z]/)) {
		passwordValid = false;
	}
	if (!password.match(/[0-9]/)) {
		passwordValid = false;
	}
	return passwordValid;
};

export const getParameterByName = (theName, theUrl) => {
	const url = theUrl || window.location.href;
	const name = theName.replace(/[\[\]]/g, "\\$&");
	const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
	const results = regex.exec(url);
	if (!results) {
		return null;
	}
	if (!results[2]) {
		return "";
	}
	return decodeURIComponent(results[2].replace(/\+/g, " "));
};

export const detectBrowser = () => {
	// Opera 8.0+
	const isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(" OPR/") >= 0;

	// Firefox 1.0+
	const isFirefox = typeof InstallTrigger !== "undefined";

	// Safari 3.0+ "[object HTMLElementConstructor]"
	const isSafari =
		/constructor/i.test(window.HTMLElement) ||
		(function (p) {
			return p.toString() === "[object SafariRemoteNotification]";
		})(!window["safari"] || (typeof safari !== "undefined" && safari.pushNotification));

	// Internet Explorer 6-11
	const isIE = /* @cc_on!@ */ false || !!document.documentMode;

	// Edge 20+
	const isEdge = !isIE && !!window.StyleMedia;

	// Chrome 1+
	const isChrome = !!window.chrome && !!window.chrome.webstore;

	// Blink engine detection
	const isBlink = (isChrome || isOpera) && !!window.CSS;
	// return "ie";
	return isBlink
		? "blink"
		: isChrome
		? "chrome"
		: isEdge
		? "edge"
		: isIE
		? "ie"
		: isSafari
		? "safari"
		: isFirefox
		? "firefox"
		: isOpera
		? "opera"
		: undefined;
};
